<script>
  import state from '../states'
  import {onMount, afterUpdate} from 'svelte'
  import moment from 'moment'
  import db from '../db'
  import ApexCharts from 'apexcharts'

  let {chart, chartData} = state
  let Chart = {}
  let val = 0
  let memo = ''


  const logData = async () =>{

    if(val != undefined ){
        let res = await db.data.add({
          chartId: $chart,
          ts: Date.now(),
          value: val,
          memo: memo || ''
        })
      chartData.set(getChartData())

      Chart.appendData([{
        data: [val]
      }])
     

    }
  }

  const getChartData =  async ()=>{
    let result =  await db.data.where({chartId:$chart}).toArray()
    let labels = []
    let data = []
    let day =''
    for(let x =0 ; x < result.length; x++){
    if(moment(result[x].ts).format('MM-DD') == day){
      labels.push( moment(result[x].ts).format('hh:mm:ss'))
    }
      else{
        day= moment(result[x].ts).format('MM-DD')
        labels.push( moment(result[x].ts).format('MM-DD hh:mm:ss'))
      }
    data.push(result[x].value)

  }

  let payload ={

    chart: {
      width:'100%',
      height:560,
      type: 'line',
      zoom: {
          type: 'x',
          enabled: true,
          autoScaleYaxis: true
        },
      toolbar: {
          autoSelected: 'zoom'
        }
    },
    series: [{
      name: $chart,
      data: data
    }],
    xaxis: {
      show:false,
      categories: labels
    }

  }

  return payload

  } 


  onMount(  async () => {

    let option = await getChartData()
    Chart = new ApexCharts(document.querySelector("#chart"), option);
    Chart.render();
    
  })

</script>

<div>
  <div id="chart" > </div>
  <div>
    <input type="number" bind:value = {val} placeholder="value"/>
    <input type="text" bind:value = {memo} placeholder="memo"/>
    <button type="button" on:click = {logData} >Save</button>
  </div>
</div>